import React from 'react';

export function PrivacyIcon({ className, width = 20, height = 20 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 1.66699C11.8409 1.66699 13.333 3.15905 13.333 5V6.66699H15.833C16.7534 6.66699 17.4998 7.41268 17.5 8.33301V16.667C17.4998 17.5873 16.7534 18.333 15.833 18.333H4.16699C3.24663 18.333 2.50018 17.5873 2.5 16.667V8.33301C2.50018 7.41268 3.24663 6.66699 4.16699 6.66699H6.66699V5C6.66699 3.15905 8.15905 1.66699 10 1.66699ZM4.16699 16.667H15.833V8.33301H4.16699V16.667ZM10 10C10.9205 10 11.667 10.7465 11.667 11.667C11.6669 12.2833 11.3305 12.8192 10.833 13.1074V14.167C10.8328 14.6271 10.4601 15 10 15C9.53987 15 9.16717 14.6271 9.16699 14.167V13.1074C8.66948 12.8192 8.33313 12.2833 8.33301 11.667C8.33301 10.7465 9.07953 10 10 10ZM10 3.33301C9.07953 3.33301 8.33301 4.07953 8.33301 5V6.66699H11.667V5C11.667 4.07953 10.9205 3.33301 10 3.33301Z"
        fill="white"
      />
      <path
        d="M10 1.66699C11.8409 1.66699 13.333 3.15905 13.333 5V6.66699H15.833C16.7534 6.66699 17.4998 7.41268 17.5 8.33301V16.667C17.4998 17.5873 16.7534 18.333 15.833 18.333H4.16699C3.24663 18.333 2.50018 17.5873 2.5 16.667V8.33301C2.50018 7.41268 3.24663 6.66699 4.16699 6.66699H6.66699V5C6.66699 3.15905 8.15905 1.66699 10 1.66699ZM4.16699 16.667H15.833V8.33301H4.16699V16.667ZM10 10C10.9205 10 11.667 10.7465 11.667 11.667C11.6669 12.2833 11.3305 12.8192 10.833 13.1074V14.167C10.8328 14.6271 10.4601 15 10 15C9.53987 15 9.16717 14.6271 9.16699 14.167V13.1074C8.66948 12.8192 8.33313 12.2833 8.33301 11.667C8.33301 10.7465 9.07953 10 10 10ZM10 3.33301C9.07953 3.33301 8.33301 4.07953 8.33301 5V6.66699H11.667V5C11.667 4.07953 10.9205 3.33301 10 3.33301Z"
        fill="black"
      />
    </svg>
  );
}
